import { makeHttpClient, _unwrapAxiosResponse } from "./http";
import env from "@/environment/env.json";
import Products from "@/views/DataManagement/Products.vue";
import { DialogProgrammatic as Dialog } from "buefy";
export interface CDFTransactionData {
  id?: number;
  stream: number;
  sheet_name: string;
  field_name: string;
  description: string;
  allowed_values: string;
  example_data: string;
  field_type: number;
}
const exportLargeCount = 65000;

export default class CDFTransactionDataService {
  private httpClient = makeHttpClient();

  getAll(customer_id: number) {
    let url = `${env.cdfTransactionUrl}`;

    if (customer_id != null) {
      url = url + `?customer_id=${customer_id}`;
    }
    return _unwrapAxiosResponse(this.httpClient.get<CDFTransactionData>(url));
  }

  saveMatchedData(customer_id: any, data: any) {
    const headers = {
      headers: {
        "Content-Type": "application/json",
        tenant: customer_id
      }
    };
    const params = {
      product: data.product[0],
      transactions: data.transaction,
      match_type: data.matchType
    };
    const url = `${env.dataManagementTempUrl}transaction/manual-match/`;
    return _unwrapAxiosResponse(
      this.httpClient.post<CDFTransactionData>(url, params, headers)
    );
  }

  manualUnmatch(customer_id: any, transactionIds: number[]) {
    const headers = {
      headers: {
        "Content-Type": "application/json",
        tenant: customer_id
      }
    };
    const params = {
      transactions: transactionIds
    };
    const url = `${env.dataManagementTempUrl}transaction/manual-unmatch/`;
    return _unwrapAxiosResponse(this.httpClient.post(url, params, headers));
  }

  getCdfTransactionField(customer_id: number, hasNADropdown = false) {
    let url = `${env.cdfTransactionUrl}customer/template`;
    if (customer_id != null) {
      url =
        url + `?customer_id=${customer_id}` + `&na_dropdown=${hasNADropdown}`;
    } else {
      url = url + `?na_dropdown=${hasNADropdown}`;
    }

    return _unwrapAxiosResponse(this.httpClient.get<CDFTransactionData>(url));
  }

  generateCDF(cdfId: any, data: any) {
    return _unwrapAxiosResponse(
      this.httpClient.post<CDFTransactionData>(
        env.cdfTransactionUrl + `${cdfId}/generate_cdf/`,
        data
      )
    );
  }

  saveAsDraft(cdfId: any, data: any) {
    return _unwrapAxiosResponse(
      this.httpClient.post<CDFTransactionData>(
        env.cdfTransactionUrl + `${cdfId}/save_as_draft/`,
        data
      )
    );
  }

  sendForApproval(cdfId: any, data: any) {
    return _unwrapAxiosResponse(
      this.httpClient.post<CDFTransactionData>(
        env.cdfTransactionUrl + `${cdfId}/send_for_approval/`,
        data
      )
    );
  }

  approve(cdfId: any) {
    return _unwrapAxiosResponse(
      this.httpClient.post<CDFTransactionData>(
        env.cdfTransactionUrl + `${cdfId}/confirm/`
      )
    );
  }

  reject(cdfId: any, comment: any) {
    const data = {
      comment: comment
    };
    return _unwrapAxiosResponse(
      this.httpClient.post<CDFTransactionData>(
        env.cdfTransactionUrl + `${cdfId}/reject/`,
        data
      )
    );
  }

  cdfTransactionTemplateExport(customer_id: number) {
    let url = `/cdf/cdf-transactiontemplate/`;

    if (customer_id != null) {
      url = url + `?customer_id=${customer_id}`;
    }
    this.httpClient
      .get(url, { responseType: "blob" })
      .then(({ data }) => {
        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", "CDF Transaction Template.xlsx"); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(e => {
        Dialog.alert({
          title: "Export not possible",
          message:
            "There are no approved versions yet. Please contact your Customer Account Manager for further information ",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      });
  }
  exportTransactions(
    customer: any,
    importType: any,
    ids: number[],
    count: any
  ) {
    const params = new URLSearchParams();
    params.append("tenant", customer);
    params.append("import_type", importType);
    params.append("count", count);
    if (ids.length == 0) {
      throw new Error("Please select at least one record.");
    } else {
      ids.map(id => {
        params.append("records", "" + id);
      });
      const url = `${env.dataManagementTempUrl}export/td/?${params.toString()}`;
      this.httpClient
        .get(url, { responseType: "blob" })
        .then(({ data }) => {
          const downloadUrl = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          if (count >= exportLargeCount) {
            return 1;
          } else {
            link.href = downloadUrl;
            link.setAttribute("download", "export_transactions.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
        })
        .catch(err => {
          Dialog.alert({
            title: "Export not possible",
            message: "There is some issue with exporting the file.",
            type: "is-danger",
            ariaRole: "alertdialog",
            ariaModal: true
          });
          return err;
        });
    }
  }
  exportAllTransactions(
    customer: any,
    importType: any,
    query: any,
    count: any,
    import_id: any
  ) {
    const params = new URLSearchParams();
    params.append("tenant", customer);
    params.append("import_type", importType);
    params.append("count", count);
    params.append("import_workflow_id", import_id);

    const url =
      `${env.dataManagementTempUrl}export/td/all/?${params.toString()}` + query;
    return _unwrapAxiosResponse(
      this.httpClient.get(url, { responseType: "blob" }).then(
        ({ data }) => {
          const downloadUrl = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          if (count >= exportLargeCount) {
            return 1;
          } else {
            link.href = downloadUrl;
            link.setAttribute("download", "export_all_transactions.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
            return data;
          }
        },
        err => {
          Dialog.alert({
            title: "Export not possible",
            message: "There is some issue with exporting the file.",
            type: "is-danger",
            ariaRole: "alertdialog",
            ariaModal: true
          });
          return err;
        }
      )
    );
  }
  saveBulkComment(
    customer: any,
    ids: number[],
    query: any,
    allRecords: boolean,
    data: any
  ) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        tenant: customer
      }
    };
    const params = new URLSearchParams();
    params.append("tenant", customer);
    params.append("comment", data);
    params.append("all_records", allRecords.toString());
    if (ids.length > 0 && !allRecords) {
      ids.map(id => {
        params.append("records", "" + id);
      });
    }
    const url =
      `${
        env.dataManagementTempUrl
      }transaction/bulk/comment/?${params.toString()}` + query;
    return _unwrapAxiosResponse(
      this.httpClient.get<CDFTransactionData>(url, headers)
    );
  }
}
